import { render } from "./BudgetCreate.vue?vue&type=template&id=dfcc3bc8&scoped=true"
import script from "./BudgetCreate.vue?vue&type=script&lang=js"
export * from "./BudgetCreate.vue?vue&type=script&lang=js"

import "./BudgetCreate.vue?vue&type=style&index=0&id=dfcc3bc8&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfcc3bc8"]])

export default __exports__